<ng-template #attente>
  <div class="car-page" style="justify-content: center; align-items: center; min-height: 50vh;">
    <div style="width: 200px;">
      <div class="car-progress-bar">
        <div class="car-progress-bar__inner"></div>
      </div>
      <p class="car-page__subtitle" style="text-align: center;">Chargement du module blog...</p>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="!generaleService.disabled; else attente">
  <div class="car-page">

    <div class="car-page__header">
      <h1 class="car-page__title">
        <div class="car-page__title-icon">
          <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z" />
          </svg>
        </div>
        Gestion des Blogues
      </h1>
      <p class="car-page__subtitle">Créez, modifiez et organisez vos articles de blogue</p>
    </div>

    <div class="grp-blog-layout">

      <div class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">Éditeur d'Article</div>
        </div>

        <div class="car-panel__body">

          <div class="grp-form-strip" style="align-items: flex-end; margin-bottom: 24px;">

            <div class="grp-img-upload" (click)="openFrmImage('ajouterProncipale')" style="margin-right: 8px;">
              <span
                style="font-size: 10px; color: var(--tx-subtle); display: block; margin-bottom: 4px; text-align: center;">1300
                x 400</span>
              <div class="grp-img-upload__preview" style="width: 120px; height: 60px; border-radius: var(--radius-sm);">
                <img [src]="mainImage.File_Content" alt="Bannière principale" />
                <div class="grp-img-upload__overlay">
                  <span>Bannière</span>
                </div>
              </div>
            </div>

            <div class="car-field car-field--grow">
              <label class="car-label">Type de blogue</label>
              <select class="car-input" name="blogueTypeSelect" [(ngModel)]="blogue.ecBlog_Code"
                (change)="ecBlogD_CodeChange()" required [disabled]="generaleService.disabled">
                <option value="" disabled selected>Sélectionnez un type</option>
                <option *ngFor="let type of listeType" [value]="type.value">{{ type.text }}</option>
              </select>
            </div>

            <div class="car-field car-field--grow">
              <label class="car-label">Sous-type</label>
              <select class="car-input" name="blogueSubTypeSelect" [(ngModel)]="blogue.ecBlogD_Groupe" required
                [disabled]="generaleService.disabled">
                <option value="" disabled selected>Sélectionnez un sous-type</option>
                <option *ngFor="let type of listeSoustTypeFiltred" [value]="type.code">{{ type.fr }}</option>
              </select>
            </div>

            <div class="car-toolbar" style="margin-bottom: 2px;">
              <button class="car-btn car-btn--slate" (click)="modifier()" [disabled]="generaleService.disabled">
                <span *ngIf="generaleService.disabled" class="car-spinner"></span> Modifier
              </button>
              <button class="car-btn car-btn--primary" (click)="ajouter()" [disabled]="generaleService.disabled">
                <span *ngIf="generaleService.disabled" class="car-spinner"></span> Ajouter
              </button>
              <button class="car-btn car-btn--danger" (click)="supprimer()" [disabled]="generaleService.disabled">
                <span *ngIf="generaleService.disabled" class="car-spinner"></span> Supprimer
              </button>
              <button *ngIf="blogue.ecBlog_Code" class="car-btn car-btn--slate" (click)="showListeSousType(frmSousType)"
                [disabled]="generaleService.disabled">
                Gérer Sous-types
              </button>
            </div>
          </div>

          <div class="grp-accordion-group">

            <details class="car-details" open>
              <summary class="car-details__summary">Titre Principal</summary>
              <div class="car-details__content">
                <div class="grp-editor-grid">
                  <div class="grp-editor-container">
                    <angular-editor [config]="editorConfig2" name="blogueMainTitleFr"
                      placeholder="Titre principal (Français)" [(ngModel)]="blogue_TitreFr"></angular-editor>
                  </div>
                  <div class="grp-editor-container">
                    <angular-editor [config]="editorConfig2" name="blogueMainTitleEn"
                      placeholder="Titre principal (Anglais)" [(ngModel)]="blogue_TitreEn"></angular-editor>
                  </div>
                </div>
              </div>
            </details>

            <details class="car-details">
              <summary class="car-details__summary">Titre 1</summary>
              <div class="car-details__content">
                <div class="grp-editor-grid">
                  <div class="grp-editor-container">
                    <angular-editor [config]="editorConfig2" name="blogueTitle1Fr" placeholder="Titre 1 (Français)"
                      [(ngModel)]="blogue_T1Fr"></angular-editor>
                  </div>
                  <div class="grp-editor-container">
                    <angular-editor [config]="editorConfig2" name="blogueTitle1En" placeholder="Titre 1 (Anglais)"
                      [(ngModel)]="blogue_T1En"></angular-editor>
                  </div>
                </div>
              </div>
            </details>

            <details class="car-details">
              <summary class="car-details__summary">Paragraphe 1</summary>
              <div class="car-details__content">
                <div class="grp-editor-grid">
                  <div class="grp-editor-container">
                    <angular-editor [config]="editorConfig2" name="bloguePara1Fr" placeholder="Paragraphe 1 (Français)"
                      [(ngModel)]="blogue_P1Fr"></angular-editor>
                  </div>
                  <div class="grp-editor-container">
                    <angular-editor [config]="editorConfig2" name="bloguePara1En" placeholder="Paragraphe 1 (Anglais)"
                      [(ngModel)]="blogue_P1En"></angular-editor>
                  </div>
                </div>
              </div>
            </details>

            <details class="car-details">
              <summary class="car-details__summary">Titre 2</summary>
              <div class="car-details__content">
                <div class="grp-editor-grid">
                  <div class="grp-editor-container">
                    <angular-editor [config]="editorConfig2" name="blogueTitle2Fr" placeholder="Titre 2 (Français)"
                      [(ngModel)]="blogue_T2Fr"></angular-editor>
                  </div>
                  <div class="grp-editor-container">
                    <angular-editor [config]="editorConfig2" name="blogueTitle2En" placeholder="Titre 2 (Anglais)"
                      [(ngModel)]="blogue_T2En"></angular-editor>
                  </div>
                </div>
              </div>
            </details>

            <details class="car-details">
              <summary class="car-details__summary">Paragraphe 2</summary>
              <div class="car-details__content">
                <div class="grp-editor-grid">
                  <div class="grp-editor-container">
                    <angular-editor [config]="editorConfig2" name="bloguePara2Fr" placeholder="Paragraphe 2 (Français)"
                      [(ngModel)]="blogue_P2Fr"></angular-editor>
                  </div>
                  <div class="grp-editor-container">
                    <angular-editor [config]="editorConfig2" name="bloguePara2En" placeholder="Paragraphe 2 (Anglais)"
                      [(ngModel)]="blogue_P2En"></angular-editor>
                  </div>
                </div>
              </div>
            </details>

            <details class="car-details">
              <summary class="car-details__summary">Titre 3</summary>
              <div class="car-details__content">
                <div class="grp-editor-grid">
                  <div class="grp-editor-container">
                    <angular-editor [config]="editorConfig2" name="blogueTitle3Fr" placeholder="Titre 3 (Français)"
                      [(ngModel)]="blogue_T3Fr"></angular-editor>
                  </div>
                  <div class="grp-editor-container">
                    <angular-editor [config]="editorConfig2" name="blogueTitle3En" placeholder="Titre 3 (Anglais)"
                      [(ngModel)]="blogue_T3En"></angular-editor>
                  </div>
                </div>
              </div>
            </details>

            <details class="car-details">
              <summary class="car-details__summary">Paragraphe 3</summary>
              <div class="car-details__content">
                <div class="grp-editor-grid">
                  <div class="grp-editor-container">
                    <angular-editor [config]="editorConfig2" name="bloguePara3Fr" placeholder="Paragraphe 3 (Français)"
                      [(ngModel)]="blogue_P3Fr"></angular-editor>
                  </div>
                  <div class="grp-editor-container">
                    <angular-editor [config]="editorConfig2" name="bloguePara3En" placeholder="Paragraphe 3 (Anglais)"
                      [(ngModel)]="blogue_P3En"></angular-editor>
                  </div>
                </div>
              </div>
            </details>

            <details class="car-details">
              <summary class="car-details__summary">Images de Contenu</summary>
              <div class="car-details__content">

                <div style="margin-bottom: 16px;">
                  <button class="car-btn car-btn--primary" (click)="openFrmImage('ajouter')"
                    [disabled]="generaleService.disabled">
                    <span *ngIf="generaleService.disabled" class="car-spinner"></span>
                    Ajouter une image
                  </button>
                  <input id="input_file" type="file" style="display: none" name="blogueContentImageUploader"
                    (change)="onChangeImagefile($event)" />
                </div>

                <div class="grp-gallery-roll">
                  <div *ngFor="let img of listeImagesSelectedBlogue" class="grp-gallery-item">
                    <div class="grp-gallery-item__img-box" (click)="openFrmImage('modifier', img)">
                      <img [id]="img.File_Id" [src]="img.File_Content" alt="Blog Image" />
                    </div>
                  </div>
                </div>

              </div>
            </details>

          </div>
        </div>
      </div>

      <div class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">Liste des Blogues</div>
        </div>
        <div class="car-panel__body">
          <app-liste #listeBlogueComponen [showFilter]="false" [heightTable]="'600'" [displayedColumnsBrut]="columns"
            (btnTable)="clickBtnHeat($event)"></app-liste>
        </div>
      </div>

    </div>
  </div>
</ng-container>

<ng-template #frmSousType>
  <div style="display: flex; flex-direction: column; gap: 16px; padding: 8px;">

    <div class="grp-form-strip" style="align-items: flex-end;">
      <div class="car-field car-field--grow">
        <label class="car-label">Nom du sous-type (Français)</label>
        <input class="car-input" name="sousTypeInputFr" [(ngModel)]="sousTypeFr" placeholder="Ex: Nouveautés"
          [disabled]="generaleService.disabled" />
      </div>

      <div class="car-field car-field--grow">
        <label class="car-label">Nom du sous-type (Anglais)</label>
        <input class="car-input" name="sousTypeInputEn" [(ngModel)]="sousTypeEn" placeholder="Ex: News"
          [disabled]="generaleService.disabled" />
      </div>

      <div class="car-toolbar" style="margin-bottom: 2px;">
        <button class="car-btn car-btn--primary" (click)="ajouterSousType()" [disabled]="generaleService.disabled">
          <span *ngIf="generaleService.disabled" class="car-spinner"></span> Ajouter
        </button>
        <button class="car-btn car-btn--danger" (click)="supprimerSousType()" [disabled]="generaleService.disabled">
          <span *ngIf="generaleService.disabled" class="car-spinner"></span> Supprimer
        </button>
      </div>
    </div>

    <div class="car-table-wrap">
      <app-liste #listeSousTypeComponen [showFilter]="false" [heightTable]="'300'"
        [displayedColumnsBrut]="columnsSousType"></app-liste>
    </div>
  </div>
</ng-template>